import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <defs>
        <style>{`.prefix__cls-2{fill:${props.fillPrimary}}`}</style>
      </defs>
      <g id="prefix__Group_2352" transform="translate(-222 -508)">
        <rect
          id="prefix__Rectangle_835"
          width={29}
          height={29}
          fill={props.fillSecondary}
          rx={10}
          transform="translate(222 508)"
        />
        <g id="prefix__Group_2351" transform="translate(198.104 512.876)">
          <path
            id="prefix__Path_5523"
            d="M121.472 101.381a17.1 17.1 0 00.646 3.466 9.384 9.384 0 004.411 5.881 9.384 9.384 0 004.411-5.881 17.1 17.1 0 00.646-3.466l-5.057-2.529z"
            className="prefix__cls-2"
            transform="translate(-88.133 -95.136)"
          />
          <path
            id="prefix__Path_5524"
            d="M46.887 4.5a.564.564 0 00-.311-.475L38.648.059a.564.564 0 00-.5 0l-7.932 3.964a.564.564 0 00-.311.475 19.979 19.979 0 00.8 6.054 14.77 14.77 0 002.422 4.9 11.461 11.461 0 005.073 3.759.564.564 0 00.4 0 11.461 11.461 0 005.069-3.758 14.77 14.77 0 002.422-4.9 19.979 19.979 0 00.8-6.054zm-8.241 12.231a.564.564 0 01-.5 0 10.371 10.371 0 01-5.241-6.694 18.409 18.409 0 01-.719-4.093.564.564 0 01.314-.544l5.647-2.824a.564.564 0 01.5 0L44.3 5.4a.564.564 0 01.311.539 18.41 18.41 0 01-.719 4.093 10.371 10.371 0 01-5.241 6.694z"
            className="prefix__cls-2"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
